import * as React from 'react';

function SvgP1(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.1 10.1" {...props}>
      <path d="M3.5 1.8c-.9 0-1.6.1-2.1.1v6.7h1.5V6.2h.5c.9 0 1.7-.2 2.2-.7.4-.4.6-1 .6-1.6 0-.7-.3-1.2-.7-1.6-.4-.3-1.1-.5-2-.5zM3.4 5h-.5V3c.1 0 .3-.1.6-.1.8 0 1.2.4 1.2 1 0 .7-.5 1.1-1.3 1.1z" />
      <text
        transform="translate(5.582 8.6)"
        fontSize={9}
        fontFamily="helvetica"
      >
        {'1'}
      </text>
    </svg>
  );
}

export default SvgP1;
